import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import { WebService } from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import { DateTime } from "luxon";
import _, {  } from "underscore";
import { ActionPermission, PageInfo } from "../PageInfo";
import { Box } from "@mui/material";
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import { NoRecordTemplate } from "../../Services/TableComponent";

import { StandardConst } from "../../Services/StandardConst";
import { DateRange } from "../Dashboard/Company/CompanyDashboard";
import ActionButton from "../../Services/ActionButton";
import BootstrapModal from "react-bootstrap/Modal";
import { Check } from "@mui/icons-material";
import * as XLSX from "sheetjs-style";
import { Button } from "@mui/material";



const AttendanceSummaryReport = () => {
  const dispatch = useDispatch();
const tableRef = useRef(null);
  // PageInfo({ pageTitle: "Attendance Summary Report" });
  PageInfo({ pageTitle: "Attendance Reconciliation Report" });
   
  // const MasterPageName = "Attendance Summary Report";
  const MasterPageName = "Attendance Reconciliation Report";
  
  const refModalInformation = useRef();
  const permissionList = useSelector((s) => s.auth.PermissionList??[]);

  const [permission, SetPermission] = useState({});
  
  const [attendanceData, setAttendanceData] = useState([]);
  const [daysArray,  setDaysArray] = useState(new Array(31).fill(null));
// const { UserId, RoleId, RoleName } = useSelector((state) => state.auth) ?? {};
const loggedUser = useSelector((s) => s.auth.LoggedUser ?? 0);
const Roles = useSelector((s) => s.auth.AssignRole ?? {});
// const authData = useSelector((state) => state.auth);
// console.log("Auth Data:", authData);





const authData = useSelector((state) => state.auth);
  // console.log('AUTH',authData)
  const userType = authData?.BasicInfo?.UserType;
  const employeeId = authData?.BasicInfo?.EmployeeId;
  const Designation = authData?.BasicInfo?.Designation;
  
  const ChildUsers = authData?.ChildUsers;
  // console.log(ChildUsers,'userType===',userType)


// console.log('AJ---',authData);
  useEffect(() => {
    SetPermission({
      // ManageSearchAllUsers: ActionPermission("Attendance Report - Search All Users"),
    });
  }, [permissionList]);

  const [bData, setBData] = React.useState([
    {
      title: "Report",
      hrefLink: "#",
    },
    {
      title: "Attendance Summary Report",
      hrefLink: "#",
    },
  ]);

  // const exportToExcel = () => {
  //   const table = tableRef.current;

  //   // Convert the HTML table into a worksheet
  //   const worksheet = XLSX.utils.table_to_sheet(table);

  //   // Create a workbook and append the sheet
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

  //   // Export the workbook as Excel file
  //   XLSX.writeFile(workbook, "attendance.xlsx");
  // };
function excelHex(color) {
  if (!color) return "000000";

  // If #hex format
  color = color.trim();
  if (color.startsWith("#")) color = color.substring(1);

  // If already 6-digit hex
  if (/^[0-9A-Fa-f]{6}$/.test(color)) {
    return color.toUpperCase();
  }

  // Convert color names → RGB
  try {
    const temp = document.createElement("div");
    temp.style.color = color;
    document.body.appendChild(temp);
    const rgb = window.getComputedStyle(temp).color;
    document.body.removeChild(temp);

    const [r, g, b] = rgb.match(/\d+/g).map(Number);

    return (
      r.toString(16).padStart(2, "0") +
      g.toString(16).padStart(2, "0") +
      b.toString(16).padStart(2, "0")
    ).toUpperCase();
  } catch (e) {
    return "000000"; // fallback (black)
  }
}

const exportToExcel = () => {
  const wb = XLSX.utils.book_new();
  const wsData = [];

  // -----------------------------------
  // 1) LEGEND ROW
  // -----------------------------------
  // wsData.push([
  //   "Leave ●",
  //   "CheckIn ●",
  //   "Holiday ●",
  //   "Leave + CheckIn ●",
  //   "CheckIn + Holiday ●",
  //   "Leave + Holiday ●",
  //   "Leave + CheckIn + Holiday ●",
  //   "All Not Found ●"
  // ]);
  // -----------------------------------
// 1) LEGEND ROW (WITH COLORED DOTS)
// -----------------------------------
wsData.push([
  {
    v: "Leave ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.Leave) } } }
  },
  {
    v: "CheckIn ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.CheckIn) } } }
  },
  {
    v: "Holiday ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.Holiday) } } }
  },
  {
    v: "Leave + CheckIn ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.LeaveAndCheckIn) } } }
  },
  {
    v: "CheckIn + Holiday ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.CheckInAndHoliday) } } }
  },
  {
    v: "Leave + Holiday ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.LeaveAndHoliday) } } }
  },
  {
    v: "Leave + CheckIn + Holiday ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.LeaveAndCheckInAndHoliday) } } }
  },
  {
    v: "All Not Found ●",
    s: { font: { bold: true, color: { rgb: excelHex(StandardConst.AttendanceSummaryReportColors.AllNotFound) } } }
  }
]);

  // -----------------------------------
  // 2) HEADER ROW
  // -----------------------------------
  const header = ["No.", "Name", ...daysArray.map((d, i) => i + 1)];
  wsData.push(header);

  // -----------------------------------
  // 3) ROWS WITH CONDITIONAL DOTS
  // -----------------------------------
  attendanceData.forEach((emp) => {
    const row = [emp.SN, emp.EmployeeName];

    daysArray.forEach((_, dayIndex) => {
      const d = emp[dayIndex + 1];

      // No attendance → keep cell blank
      if (!d) {
        row.push(""); // EMPTY CELL
        return;
      }

      let dotColor = null;

      // ---- Condition Mapping ----
      if (d.Leave && !d.CheckIn && !d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.Leave;

      else if (!d.Leave && d.CheckIn && !d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.CheckIn;

      else if (d.Leave && d.CheckIn && !d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.LeaveAndCheckIn;

      else if (!d.Leave && !d.CheckIn && d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.Holiday;

      else if (!d.Leave && d.CheckIn && d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.CheckInAndHoliday;

      else if (d.Leave && !d.CheckIn && d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.LeaveAndHoliday;

      else if (d.Leave && d.CheckIn && d.Holiday)
        dotColor = StandardConst.AttendanceSummaryReportColors.LeaveAndCheckInAndHoliday;

      else
        dotColor = StandardConst.AttendanceSummaryReportColors.AllNotFound;

      // fallback if null
      const cleanedColor = dotColor
        ? dotColor.replace("#", "")
        : "000000"; // black fallback

      // row.push({
      //   v: "●",
      //   s: {
      //     font: {
      //       bold: true,
      //       color: { rgb: cleanedColor },
      //       sz: 14
      //     }
      //   }
      // });
      row.push({
  v: "●",
  s: {
    font: {
      bold: true,
      color: { rgb: excelHex(dotColor) }   // THE FIX
    }
  }
});
    });

    wsData.push(row);
  });

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Column widths
  ws["!cols"] = [
    { wch: 5 },   // No.
    { wch: 22 },  // Name
    ...daysArray.map(() => ({ wch: 5 }))
  ];

  XLSX.utils.book_append_sheet(wb, ws, "Attendance");
  XLSX.writeFile(wb, "attendance.xlsx");
};




  const fetchAttendanceList = async (SelectedYear, SelectedMonth,auth = authData) => {
    const NumberOfDasInMonth = new Date(SelectedYear, SelectedMonth, 0);
    // it is blank array for days
    const daysArray = new Array(NumberOfDasInMonth.getDate()).fill(null);
    var daysObject = daysArray.reduce((acc, _, index) => {
        const day = index + 1;
        acc[day] = null; 
        return acc;
    }, {});
    setDaysArray(new Array(NumberOfDasInMonth.getDate()).fill(null));

    let attendanceData = [];

    const EmployeeList = await WebService({
        endPoint: `CommonUtility/Edit/employees?CompanyId=${StandardConst.YesNo.Yes}&StatusId=${StandardConst.Status.Approved}`,
        dispatch,
    })

    const EmployeeCheckInList = await WebService({
        endPoint: `Attendance/getEmployeeCheckInList/${SelectedYear}/${SelectedMonth}`,
        dispatch,
    });

    const HolidayList = await WebService({
        endPoint: `CommonUtility/Edit/holidaymaster?CompanyId=${StandardConst.YesNo.Yes}`,
        dispatch,
    });
    const filteredHolidays = HolidayList.filter(holiday => {
        const holidayDate = new Date(holiday.HolidayDate);
        return holidayDate.getFullYear() === 2025;
    }).map(holidayData => {
      return {
        HolidayDate: holidayData.HolidayDate,
        HolidayDay: new Date(holidayData.HolidayDate).getDate(),
        HolidayName: holidayData.HolidayName,
      }
    });



    let EmployeeLeaveList = await WebService({
        endPoint: `Attendance/getEmployeeLeaveList/${SelectedYear}/${SelectedMonth}`,
        dispatch,
      });
      // Designation metch working code
      // console.log(Designation,'Designstion');
//       const designation = (auth?.BasicInfo?.Designation || "").toUpperCase().trim();
//       const privilegedDesignations = ["CEO", "MANAGER", "HR", "TEAM LEAD", "TEAMLEAD","ADMIN","SUPERADMIN","SUPER_ADMIN","SUPER ADMIN","TEAM MANAGER","TEAM_MANAGER"];
//  const currentEmployeeId = auth?.BasicInfo?.EmployeeId;
//       const filteredList =
//                         (!privilegedDesignations.includes(designation)) 
//                         ? EmployeeList.filter(emp => emp.EmployeeId === employeeId)
//                         : EmployeeList;
// ===========================End


const designation = (auth?.BasicInfo?.Designation || "").toUpperCase().trim();

const privilegedDesignations = [
  "CEO", "MANAGER", "HR", "TEAM LEAD", "TEAMLEAD",
  "ADMIN", "SUPERADMIN", "SUPER_ADMIN", "SUPER ADMIN",
  "TEAM MANAGER", "TEAM_MANAGER"
];

const currentEmployeeId = auth?.BasicInfo?.EmployeeId;

// Extra condition: Email match
// Extra conditions
const isCompanyEmailUser = auth?.BasicInfo?.Email === auth?.CompanyInfo?.Email;
const hasChildUsers = Array.isArray(auth?.ChildUsers) && auth?.ChildUsers.length > 0;

const canSeeFullList =
  privilegedDesignations.includes(designation) ||
  isCompanyEmailUser ||
  hasChildUsers;

const filteredList = canSeeFullList
  ? EmployeeList
  : EmployeeList.filter(emp => emp.EmployeeId === currentEmployeeId);




                         // Get employeeId from the passed auth parameter
     

     

      // console.log('Filtered employees:', filteredList.length, 'Designation:', designation);
      // console.log('EmployeeList total:', EmployeeList.length);
      // console.log('Current Employee ID:', currentEmployeeId);
      // console.log('Filtered List123:', filteredList);

      filteredList.map((employee, i) => {


        const obj = {
          SN : parseInt(i+1),
          EmployeeName : employee.FullName,
          Attendance : ""
        };
        

        
        Object.keys(daysObject).map((key) => {
          filteredHolidays.map((holiday) => {
            const holidayDate = new Date(holiday.HolidayDate);
            const holidayMonth = holidayDate.getMonth() + 1;
            if (parseInt(holiday.HolidayDay) === parseInt(key) && parseInt(SelectedMonth) === parseInt(holidayMonth)) {
              const oj = {Holiday : 1}
              daysObject[key] = {...daysObject[key], ...oj};
            }
          })

          EmployeeCheckInList.filter(item => item.EmployeeId === employee.EmployeeId).map((employeeCheckIn) => {
            if (parseInt(employeeCheckIn.CheckInDay) === parseInt(key)) {
              const oj = {CheckIn : 1}
              daysObject[key] = {...daysObject[key], ...oj};
            }
          })

          EmployeeLeaveList.filter(item => item.EmployeeId === employee.EmployeeId).map((EmployeeLeave) => {
            if (parseInt(EmployeeLeave.LeaveDay) === parseInt(key)) {
              const oj = {Leave : 1}
              daysObject[key] = {...daysObject[key], ...oj};
            }
          })


        });


        const concatenatedObject = {
          ...obj,
          ...daysObject 
        };
        attendanceData.push(concatenatedObject);

        daysObject = daysArray.reduce((acc, _, index) => {
          const day = index + 1;
          acc[day] = null;
          return acc;
        }, {});
        
      });

    setAttendanceData(attendanceData);
  };

 useEffect(() => {
  const date = new Date();
  const selectedYear = date.getFullYear();
  const selectedMonth = (date.getMonth() + 1).toString();

  // Run only when authData is ready
  if (authData && authData.BasicInfo) {
    fetchAttendanceList(selectedYear, selectedMonth, authData);
  }
}, [authData]);

  const stylecss = {textAlign: 'left !important'};
// console.log(attendanceData,'Abhi Attend')
  return (
    <>
      <div className="base-container">
        <Box
          sx={{
            width: 1,
          }}
        >
          <h5 className="ms-4 mt-2">{MasterPageName}</h5>
          <div className="ms-4">
            <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
          </div>
        </Box>
        <div className="row primary-bg-color text-white p-0 m-0" style={{height : "40px"}}>
            <div className="col-11 d-flex justify-content-center align-items-center">
              
              <DateRange
                  ButtonColor={"white"}
                  setDateRange={({ StartDate, EndDate }) => {
                          const date = new Date(StartDate);
                          const selectedYear = date.getFullYear();
                          let selectedMonth = (date.getMonth() + 1).toString(); 
                          fetchAttendanceList(selectedYear, selectedMonth, authData);
                  }}
              />
            </div>
            <div className="col-1 d-flex justify-content-center align-items-center">
            
               <Button
                                    variant="outline-success"
                                    onClick={() => exportToExcel()}
                                    sx={{ width: "100%"  }}
                                    className="tester"
                                  >
                                    <i className="fa fa-file-excel-o me-2"></i> Export
                                  </Button>
              <OpenInfoModal ref={refModalInformation} />
              <ActionButton
                  className="text-align-end text-white ms-2 me-3"
                  onClick={async () => await refModalInformation.current.openModal()}
                  IconName="Information"
                  IconTooltip="Information"
                  id="info"
              />
            </div>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }} className="mt-2 mx-2">
  <span style={tagStyle}>
    Leave
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.Leave)} />
  </span>

  <span style={tagStyle}>
    CheckIn
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.CheckIn)} />
  </span>

  <span style={tagStyle}>
    Holiday
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.Holiday)} />
  </span>

  <span style={tagStyle}>
    Leave + CheckIn
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.LeaveAndCheckIn)} />
  </span>

  <span style={tagStyle}>
    CheckIn + Holiday
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.CheckInAndHoliday)} />
  </span>

  <span style={tagStyle}>
    Leave + Holiday
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.LeaveAndHoliday)} />
  </span>

  <span style={tagStyle}>
    Leave + CheckIn + Holiday
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.LeaveAndCheckInAndHoliday)} />
  </span>

  {/* Missing case for AllNotFound */}
  <span style={tagStyle}>
    All Not Found
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.AllNotFound)} />
  </span>
</div>
        <div className="mt-2">
            {(attendanceData.length > 0) ? (
              <div  className="table-responsive p-0" style={{ overflow: "none" }}>
                <table id="attendance_table" ref={tableRef}>
                    <thead>
                        <tr className="bg-info">
                            <th >No.</th>
                            <th >Name</th>
                            {daysArray.map((_, index) => (
                                <th key={index} >{parseInt(index+1) < 10 ? '0' + parseInt(index+1) : parseInt(index+1)}</th>
                            ))}
                            {/* <th >Attendance</th> */}
                        </tr>
                    </thead>
                    <tbody>
                    {attendanceData.map((employeeRow, index) => {
                        
                            return (
                                <tr key={index}>
                                    <td>{employeeRow.SN}</td>
                                    <td style={stylecss}>{employeeRow.EmployeeName}</td>
                                    {daysArray.map((_, j) => {
                                      const dayValues = employeeRow[j + 1];
                                      if(dayValues !== null){
                                        var colorDot = 'blue';

                                        if((dayValues?.Leave === 1) && (dayValues?.CheckIn === undefined) && (dayValues?.Holiday === undefined)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.Leave;
                                        }else if((dayValues?.Leave === undefined) && (dayValues?.CheckIn === 1) && (dayValues?.Holiday === undefined)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.CheckIn;
                                        }else if((dayValues?.Leave === 1) && (dayValues?.CheckIn === 1) && (dayValues?.Holiday === undefined)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.LeaveAndCheckIn;
                                        }else if((dayValues?.Leave === undefined) && (dayValues?.CheckIn === undefined) && (dayValues?.Holiday === undefined)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.AllNotFound;
                                        }else if((dayValues?.Leave === undefined) && (dayValues?.CheckIn === undefined) && (dayValues?.Holiday === 1)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.Holiday;
                                        }else if((dayValues?.Leave === undefined) && (dayValues?.CheckIn === 1) && (dayValues?.Holiday === 1)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.CheckInAndHoliday;
                                        }else if((dayValues?.Leave === 1) && (dayValues?.CheckIn === undefined) && (dayValues?.Holiday === 1)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.LeaveAndHoliday;
                                        }else if((dayValues?.Leave === 1) && (dayValues?.CheckIn === 1) && (dayValues?.Holiday === 1)){
                                          colorDot = StandardConst.AttendanceSummaryReportColors.LeaveAndCheckInAndHoliday;
                                        }

                                        return <td key={j+1}><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: colorDot }}></span></td>
                                      }else{
                                        return <td></td>
                                      }
                                    })}
                                    {/* <td></td> */}
                                </tr>
                            );
                        return null;
                    })}
                    </tbody>
                </table>
              </div>
            ) : (
                <NoRecordTemplate
                    headerValue="No employees found"
                    subHeaderValue="Please add some employees"
                    imageUrl={StandardConst.imageNoRecordsFound}
                />
            )}
        </div>
      </div>
    </>
  );
};

const OpenInfoModal = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  useImperativeHandle(ref, () => ({
    openModal: async () => {
      setShow(true);
    },
  }));

  return (
    <BootstrapModal show={show} onHide={handleClose}>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>Associated colors for Attendance Summary</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
      
      <ul style={{ listStyle: "none", padding: 0 }}>
  <li style={{ marginBottom: "8px" }}>
    <strong>Leave</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.Leave)} />
  </li>
  <li style={{ marginBottom: "8px" }}>
    <strong>CheckIn</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.CheckIn)} />
  </li>
  <li style={{ marginBottom: "8px" }}>
    <strong>Holiday</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.Holiday)} />
  </li>
  <li style={{ marginBottom: "8px" }}>
    <strong>Leave + CheckIn</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.LeaveAndCheckIn)} />
  </li>
  <li style={{ marginBottom: "8px" }}>
    <strong>CheckIn + Holiday</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.CheckInAndHoliday)} />
  </li>
  <li style={{ marginBottom: "8px" }}>
    <strong>Leave + Holiday</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.LeaveAndHoliday)} />
  </li>
  <li style={{ marginBottom: "8px" }}>
    <strong>Leave + CheckIn + Holiday</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.LeaveAndCheckInAndHoliday)} />
  </li>
  
  {/* Adding the missing AllNotFound case */}
  <li style={{ marginBottom: "8px" }}>
    <strong>All Not Found</strong>
    <span style={dotStyle(StandardConst.AttendanceSummaryReportColors.AllNotFound)} />
  </li>
</ul>



      </BootstrapModal.Body>
    </BootstrapModal>
  );
});


export default AttendanceSummaryReport;
const dotStyle = (color) => ({
  display: "inline-block",
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  backgroundColor: color,
  marginLeft: "10px",
});

const tagStyle = {
  display: "inline-flex",
  alignItems: "center",
  padding: "6px 12px",
  borderRadius: "20px",
  border: "1px solid #ccc",
  backgroundColor: "#f8f9fa",
  fontSize: "14px",
  whiteSpace: "nowrap", // keep text in one line
};